import {getApp, getApps, initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import 'firebase/firestore';
import {getFirestore} from 'firebase/firestore';
import {getFunctions} from 'firebase/functions';
import {getStorage} from 'firebase/storage';
import {initializeAppCheck, ReCaptchaV3Provider} from 'firebase/app-check';
import {
  getAI,
  getGenerativeModel,
  getImagenModel,
  GoogleAIBackend,
} from 'firebase/ai';
import {Keys} from 'hubbl-shared';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

if (!getApps().length) {
  initializeApp(firebaseConfig);
}

// Initialize App Check with reCAPTCHA v3
if (process.env.REACT_APP_RECAPTCHA_KEY) {
  initializeAppCheck(getApp(), {
    provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

const firebaseAuth = getAuth(getApp());
const firestore = getFirestore(getApp());
const firebaseFunctions = getFunctions(getApp(), Keys.defaultFunctionsRegion);
const firebaseStorage = getStorage(getApp());

// Initialize AI for Gemini Developer API (free tier)
const firebaseAI = getAI(getApp(), {
  backend: new GoogleAIBackend(),
});
export {
  firebaseAuth,
  firestore,
  firebaseFunctions,
  firebaseStorage,
  firebaseAI,
  getGenerativeModel,
  getImagenModel,
};
